import { MARQUEE } from "@/data/content";

export default function Marquee() {
    const items = (ariaHidden) => (
        <ul
            aria-hidden={ariaHidden || undefined}
            className="flex shrink-0 items-center"
        >
            {MARQUEE.map((item, i) => (
                <li
                    key={i}
                    className="flex items-center whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.25em] text-[#6E6D6A]"
                >
                    <span className="px-6">{item}</span>
                    <span className="text-[#C84B31]">✳</span>
                </li>
            ))}
        </ul>
    );

    return (
        <div
            data-testid="editorial-marquee"
            className="overflow-hidden border-y border-[#E5E1D8]/70 bg-[#F4F0E8]/60 py-5"
        >
            <div className="marquee-track">
                {items(false)}
                {items(true)}
            </div>
        </div>
    );
}
